import { Box, Stack } from '@mui/material';

interface StickyBlockProps {
  children: React.ReactNode;
}

const StickyBlock = ({ children }: StickyBlockProps) => {
  return (
    <Box sx={{ maxWidth: 256, minWidth: 128, position: 'relative', top: -16 }}>
      <Stack
        spacing={2}
        sx={{ pt: 2, position: 'sticky', top: 0, alignSelf: 'flex-start' }}
      >
        {children}
      </Stack>
    </Box>
  );
};

export default StickyBlock;
